import React, { PropsWithChildren } from 'react';
import { ProductBadgeProps } from './interface';
import htmlClasses from 'html-classes';

export const ProductBadge = (props: PropsWithChildren<ProductBadgeProps>) => {
  const { className = '', type, children } = props;

  return <div className={htmlClasses(`product-item__${type}`, className)}>{children}</div>;
};
